import { MessageOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import React from 'react';
import { urlAdmin } from '../../../constants';
interface YKienVanPhongProps {
    tongHopKPI: any;
}

const YKienVanPhong: React.FC<YKienVanPhongProps> = ({ tongHopKPI }) => {
    return (<Row>
        <Col span={24}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <MessageOutlined style={{ color: '#3b82f6', fontSize: '18px', marginTop: '2px' }} />
                <div>
                    <span style={{ fontWeight: 600, color: '#334155', fontSize: '14px' }}>Ý kiến của Văn phòng:</span> <div className="text-enter">{tongHopKPI.noiDung}</div>
                </div>
            </div>
        </Col>
        <Col span={24} style={{ marginBottom:"10px" }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                <PaperClipOutlined style={{ color: '#64748b', fontSize: '18px' }} />
                <label style={{ fontWeight: 600, color: '#334155', fontSize: '14px', margin: 0, marginRight: '4px' }}>
                    File đính kèm:
                </label>

                {tongHopKPI?.dsTaiLieu.map((value: any, index: number) => (
                    <div
                        key={index}
                        onClick={() => window.open(urlAdmin + value?.duongDan?.replace(/\\/g, "/"), '_blank')}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '4px 10px',
                            backgroundColor: '#e0f2fe',
                            border: '1px solid #bae6fd',
                            color: '#0369a1',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            transition: 'all 0.2s',
                            fontWeight: 500
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#bae6fd'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0f2fe'}
                    >
                        {value.tenTep}
                    </div>
                ))}
            </div>
        </Col>
    </Row>);
};

export default YKienVanPhong;
